<template>
  <v-card elevation="0" max-width="280" class="ma-0 mr-3" outlined tile>
    <div class="pa-2">
      <v-img
        class="white--text align-end"
        width="100%"
        height="170px"
        :src="item.productPic"
      >
      </v-img>
      <v-card-title
        style="
          font-size: 14px;
          line-height: 21px;
          letter-spacing: 0.15px;
          text-align: start;
          color: #000000;
        "
        class="pl-2 pb-3"
      >
        {{ item.productName }}
        <br />
        COD{{ item.productCode }}
      </v-card-title>

      <v-card-text
        class="d-flex justify-space-between text--primary pa-0 ma-0 px-1"
      >
        <v-row>
          <v-col cols="12">
            <div class="card-inside">
              <span class="span-btnCard px-1"
                >{{ item.skus.filter((x) => !x.delete_at).length }} Variações</span
              >
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
    <v-row class="linha justify-space-between text--primary pa-0 ma-0">
      <v-col
        class="pa-2"
        cols="12"
        sm="6"
        md="6"
        lg="6"
        style="text-align-last: left"
      >
        <v-btn block class="details-btn" outlined @click="action1">
          <span>Detalhar </span>
        </v-btn>
      </v-col>
      <v-col
        class="pa-0 d-flex align-end"
        cols="12"
        sm="6"
        md="6"
        lg="6"
        style="text-align-last: right"
      >
        <v-btn height="48" block class="add-btn pa-0" text @click="action2()">
          <span class="span-btnAdd pa-0">Adicionar </span>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>
.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
  padding: 3px 3px !important;
}

.add-btn {
  background-color: #bc0000;
  border-radius: 0px;
  border-top-left-radius: 10px;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.15px;
  color: #ffffff;
  transition: 0.3s;
}

.add-btn:hover {
  background: #e8161e;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}

.details-btn {
  border: 2px solid #2d3038;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.15px;
  text-transform: uppercase;

  color: #2d3038;
  transition: 0.3s;
}

.details-btn:hover {
  color: #fff !important;
  background: #000000 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.card-inside {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 26px;
  background-color: #2d3038;
}

.span-btnCard {
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.15px;
  text-transform: uppercase;
  color: #dadada;
}

.card-actions {
  padding: 0 0 0 0;
  justify-content: space-between;
}
.span-btnAdd {
  color: white;
  font-weight: bold;
}
@media (max-width: 600px) {
  .select-type {
    width: 50% !important;
  }
}
</style>

<script>
import ApiService from "../../../../services/ApiService";

export default {
  name: "ImageCard",

  props: {
    item: Object,
    textMessage: String,
    cancelBtn: String,
    okbtn: String,
    env_url: String,
  },

  data: () => ({
    loading: false,
    apiService: new ApiService(),
  }),

  methods: {
    close() {
      this.$emit("close");
    },

    action1() {
      this.$emit("action1");
    },

    action2() {
      this.$emit("action2");
    },
  },
};
</script>
